<template>
<div>
  <div class="block">
    <router-link to="/user/drills">
      <i class="fas fa-chevron-left"></i>
      <span>{{ $t('term.drillList') }}</span>
    </router-link>
  </div>

  <h1 class="title is-4">{{ titleLabel }}</h1>
  <div
    v-if="drill"
    class="block"
  >
    <div
      v-if="answerCount > 0"
      class="mt-2"
    >
      <label class="has-text-weight-semibold">{{ $t('term.score') }}</label>
      <span>{{ correctAnswerCount }} / {{ answerCount }}</span>
      <span>({{ $t('term.accuracyRate') }}: {{ correctAnswerRate }} %)</span>
    </div>
    <div class="mt-2">
      <label class="has-text-weight-semibold">{{ $t('term.spentTime') }}</label>
      <span>{{ spentTime | timeFormat }}</span>
    </div>
    <div class="mt-2">
      <label class="has-text-weight-semibold">{{ $t('term.startedAt') }}</label>
      <span>{{ drill.startedAt | dateFormat }}</span>
    </div>
    <div class="mt-2">
      <label class="has-text-weight-semibold">{{ $t('term.finishedAt') }}</label>
      <span>{{ drill.finishedAt | dateFormat }}</span>
    </div>
    <!--
    <div class="mt-2">
      <label class="has-text-weight-semibold">{{ $t('term.spentTime') }}</label>
      <span>{{ drill.drillTime | timeFormat }}</span>
    </div>
    -->
  </div>

  <ul v-if="answers.length > 0">
    <li
      v-for="answer in answers"
      class="block"
    >
      <p v-html="answer.post.postBody"></p>
      <p>{{ answer.answerBody }}</p>
      <p>
        <correct-status
          :is-correct="answer.isCorrect"
        ></correct-status>
      </p>
      <p>
        <label>{{ $t('term.spentTime') }}</label>
        <span>{{ answer.spentTime | timeFormat }}</span>
      </p>
      <p>{{ answer.finishedAt | dateFormat }}</p>
      <p>
        <router-link
          :to="`/user/answers/${answer.userAnswerId}`"
        >{{ $t('term.showExplanation') }}</router-link>
      </p>
    </li>
  </ul>

  <div v-else-if="isLoading !== false">
    <p>{{ $t('msg["Data is empty"]') }}</p>
  </div>

  <!--
  <nav v-if="hasNext" class="u-mt2r">
    <a class="u-clickable" @click="fetchPosts({ untilTime:lastItemPublishedAt })">{{ $t('common.more') }}</a>
  </nav>
  -->
</div>
</template>

<script>
import obj from '@/util/obj'
import utilDate from '@/util/date'
import { User } from '@/api'
import CorrectStatus from '@/components/atoms/CorrectStatus'

export default{
  name: 'UserDrill',

  components: {
    CorrectStatus,
  },

  data(){
    return {
      drill: null,
      answers: [],
      spentTime: 0,
    }
  },

  computed: {
    drillId() {
      return this.$route.params.drillId
    },

    titleLabel() {
      if (this.checkEmpty(this.drill) === true) return ''
      const dateStr = utilDate.localeStrFromUtcDate(this.drill.startedAt)
      const label = obj.getVal(this.drill, 'category') ? this.drill.category.label : this.$t('iterm.drill')
      return this.$t('common.targetOf', {
        'self': label,
        target: dateStr,
      })
    },

    answerCount() {
      return this.answers.length
    },

    correctAnswerCount() {
      if (!this.answers) return
      return this.answers.reduce((acc, curr) => {
        return curr.isCorrect === true ? acc + 1 : acc;
      }, 0)
    },

    correctAnswerRate() {
      if (this.answerCount === 0) return 0
      if (this.correctAnswerCount === 0) return 0
      return this.correctAnswerCount / this.answerCount * 100
    },
  },

  created() {
    this.setDrill()
    this.fetchAnswers()
  },

  methods: {
    async setDrill() {
      this.$store.dispatch('setLoading', true)
      try {
        const params = { withCategory: 1 }
        this.drill = await User.getDrills(this.drillId, params, this.userToken)
        this.spentTime = utilDate.calcSpentTimeByDatetimeStr(this.drill.startedAt, this.drill.finishedAt)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async fetchAnswers() {
      this.$store.dispatch('setLoading', true)
      try {
        this.answers = await User.getAnswersByDrillId(this.drillId, null, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>

